import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IOffert } from '../../models/offert';
import { VersicherungsnehmerListDialogService } from '../../service/partner-list-dialog.service';
import { DatenBeratungsprotokollComponent } from '../daten-beratungsprotokoll/daten-beratungsprotokoll.component';
import { PartnerComponent } from '../partner/partner.component';
import { ShareVnDataService } from 'src/app/service/share-vn-data.service';

@Component({
  selector: 'app-offert',
  templateUrl: './offert.component.html',
  styleUrls: ['./offert.component.scss']
})
export class OffertComponent implements OnInit, AfterViewInit {
  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  expertMode: boolean;

  @Input()
  privatperson: boolean;

  @Input()
  _geburtsdatum: Date;

  @Input()
  showEinzelunternehmen = false;

  @Input()
  anredenPrivatperson = false;

  @Input()
  validateAlter = (_value: Date): boolean => { return true; };

  @Input()
  antragVersicherungsnehmer: UntypedFormGroup;

  @Output()
  geburtsdatumChangedEvent = new EventEmitter<Date>();

  @ViewChild('_datenBeratungsprotokoll') datenBeratungsprotokollComponent: DatenBeratungsprotokollComponent;
  @ViewChild('_versicherungsnehmer') versicherungsnehmerComponent: PartnerComponent;

  constructor(public translateService: TranslateService, public versicherungsnehmerListDialogService: VersicherungsnehmerListDialogService,
    private shareVnDataService: ShareVnDataService) { }

  ngAfterViewInit(): void {
    this.versicherungsnehmerComponent.formGroup?.valueChanges.subscribe((data) => {
      this.shareVnDataService.setVersicherungsnehmerForAntragOffert(data, this.antragVersicherungsnehmer);
    });
  }

  static createFormGroup(fb: UntypedFormBuilder, expertMode: boolean) {
    return fb.group({
      datenBeratungsprotokoll: DatenBeratungsprotokollComponent.createFormGroup(fb),
      versicherungsnehmer: PartnerComponent.createFormGroup(fb, expertMode)
    });
  }

  ngOnInit() {
  }

  get datenBeratungsprotokoll() { return this.formGroup.get('datenBeratungsprotokoll'); }
  get versicherungsnehmer() { return this.formGroup.get('versicherungsnehmer') as UntypedFormArray; }

  setOffert(offert: IOffert) {
    this.datenBeratungsprotokollComponent.setOffertBase(offert);
    this.versicherungsnehmerComponent.setPartner(offert.Versicherungsnehmer);
  }

  getOffert(): IOffert {
    return {
      ...this.datenBeratungsprotokollComponent.getOffertBase(),
      Versicherungsnehmer: this.versicherungsnehmerComponent.getPartner(),
    } as IOffert;
  }

  partnerChanged() {
    const geburtsdatum = this.versicherungsnehmer.controls['geburtsdatum'].value;
    this.geburtsdatumChangedEvent.emit(geburtsdatum);
  }
}
